<template>
  <div class="page-subtab" style="width:100%;">
    <div-container :full="full" class="has-text-centered" padding-top="0rem" padding-bottom="0rem">
      <div class="columns is-gapless is-centered is-flex-mobile is-vcentered">
        <div class="column has-text-centered wrapper" :class="[{ 'is-11': full !== 'true' && !columnNum }, columnNum]">
          <div class="columns is-gapless is-centered is-flex-mobile is-vcentered">
            <div v-for="(titleInfo, index) in titleInfos" :key="titleInfo.title" class="column has-text-centered wrapper" :class="{ 'has-divider-right': index < (titleInfos.length - 1), 'is-active': (index === currentIndex), 'is-print': isPrint }">
              <a :href="'/?date=' + titleInfo.id" @click="onClickTitle($event, titleInfo.id, index, titleInfo.isfull, titleInfo.disabledText);" style="position:relative;display:block;">
                <h1 v-if="titleInfo.strikethrough" style="text-decoration:line-through;">{{ titleInfo.title }}</h1>
                <h1 v-else>{{ titleInfo.title }}</h1>
                <div v-if="titleInfo.disabled" style="position:absolute;left:0;top:0;width:100%;transform:translate(0,20px);transform:rotate(-4deg) translate(-15%,-70%);font-size:0.8em;">
                  <h2 style="color:#390e07;" v-html="titleInfo.disabledText"></h2>
                </div>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div-container>
  </div>
</template>

<script>
// import EventBus from '@/controllers/EventBus'
import DivContainer from '@/components/DivContainer'
export default {
  name: 'page-subtab',
  props: ['full', 'column-num', 'is-print', 'title-infos', 'selected-index'],
  components: {
    DivContainer
  },
  watch: {
    selectedIndex: function (value, oldValue) {
      // change externally
      this.currentIndex = value
    }
  },
  data () {
    return {
      // selectedIndex: 0
      currentIndex: 0
    }
  },
  computed: {
  },
  created () {
  },
  mounted () {
    // initial value
    this.currentIndex = this.selectedIndex
  },
  methods: {
    refresh: function () {
    },

    onClickTitle: function ($event, title, index, isfull, disabledText) {
      $event.preventDefault()
      // this.selectedIndex = index
      if (isfull) {
        let titleInfos = this.titleInfos
        let titleInfo = titleInfos[index]
        let id = titleInfo.id
        if (id === 'sign-up-team') {
          // alert(`We are sorry, team application is not open yet.`)
          alert(`We are sorry, ${disabledText && disabledText.toLowerCase()}.`)
        } else if (id === 'sign-up-judge') {
          // alert(`We are sorry, all judging spots are full for ${EventBus.info.year}.`)
          alert(`We are sorry, ${disabledText && disabledText.toLowerCase()}.`)
        } else {
          alert(`invalid tab.`)
        }
      } else {
        this.currentIndex = index
        this.$emit('title-changed', title)
      }
    }
  }
}
</script>

<style lang="scss">
@import "../styles/app_setting.scss";

// page-subtab

.page-subtab {
  width: 100%;

  .columns.is-gapless > .column {
    &.wrapper {
      // padding-top: 1rem;
      // padding-bottom: 1rem;
      background-color: $color-tab-inactive;
      h1, h2, h3, h4, h5, h6 {
        color: white;
        letter-spacing: 0;
      }

      &.is-active {
        background-color: $color-orange;
        h1, h2, h3, h4, h5, h6 {
          color: $color-darkbrown;
        }
      }

      h1 {
        font-size: 1.2em;
        @media screen and (min-width: $tablet) {
          font-size: 2em;
        }
      }

      &.is-print {
        display: none;
        &.is-active {
          display: block;
        }
      }
    }

    h1, h2, h3, h4, h5, h6 {
      padding-top: 0.5rem;
      padding-bottom: 0.5rem;
      color: $color-black;
      // font-size: 2.5rem;
      font-family: $font-family-title;
      text-transform: uppercase;
      // border-bottom: 5px dashed $color-beige;
    }

    .has-divider-right {
      &:after {
        content: '';
        position: absolute;
        background-color: $color-beige;
        width: 10px;
        height: 100%;
        top: 0;
        left: 50%;
        display: block;
      }

      &.is-print:after {
        display: none;
      }
    }
  }
}

</style>



// WEBPACK FOOTER //
// PageSubtab.vue?4c1aa3d8